import { MultiSelectFieldsNS } from "../models/saved-search-multiselect-fields.static";
import { SavedSearchNS } from "../models/saved-search.models";
import { DataTypeWithOperatorNS } from "../models/saved-search.static";

//*****Process Value According to DataType & Operator******
export function getSavedSearchRuleValues(rule: SavedSearchNS.IRuleList): { values: string[] | boolean[] | SavedSearchNS.ICountryStateCity[] | SavedSearchNS.AddressLatLong[], valueRefId: string[] } {
    let valueArray: string[] | boolean[] | SavedSearchNS.ICountryStateCity[] | SavedSearchNS.AddressLatLong[] = [];
    let valueRefId: string[] = [];
    if (rule) {
        let selectedDataTypeAndOperator = DataTypeWithOperatorNS.SavedSearchDataTypeWithOperator.find(x => x.DataType == rule?.filter?.fieldDataType && x.Operator == rule.operator.name);
        // String
        if (rule?.filter?.fieldDataType == 'String') {
            if (selectedDataTypeAndOperator?.Operator == 'HasValue') {
                valueArray = [];
            }
            else if (selectedDataTypeAndOperator?.NoOfValuesToBePassed == 'No_Value') {
                valueArray = [];
            }
            // else if (selectedDataTypeAndOperator?.NoOfValuesToBePassed == 'Multiple') {
            //     valueArray = [rule.value];
            // }
            else {
                if (rule.filter.valueDataType == 'User') {
                    let arrStr: any[] = [];
                    let arrRefId: string[] = [];
                    rule?.value?.forEach((val: any) => {
                        arrStr.push(val.name);
                        if (val?.id?.toString()) {
                            arrRefId.push(val.id.toString());
                        }
                    });
                    valueArray = arrStr;
                    valueRefId = arrRefId;
                }
                else if (rule.filter.valueDataType == 'Year') {
                    const dateFrom = rule.value?.getFullYear();
                    if (dateFrom) {
                        valueArray = [dateFrom.toString()];
                    }
                }
                else if (rule.filter.valueDataType == 'AutoCompleteDropdown' && MultiSelectFieldsNS.AutoCompleteDropdownFieldsArray.includes(rule.filter.field?.toLowerCase())) {
                    // let arrStr: any[] = [];
                    // if (rule.value?.name) {
                    //     arrStr = [rule.value?.name];
                    // }
                    // else if (rule.value) {
                    //     arrStr = [rule.value];
                    // }
                    // valueArray = arrStr;
                    // let arrRefId: string[] = [];
                    // valueRefId = arrRefId;

                    let arrStr: any[] = [];
                    let arrRefId: string[] = [];
                    rule?.value?.forEach((val: any) => {
                        arrStr.push(val.name);
                        if (val?.id?.toString()) {
                            arrRefId.push(val.id.toString());
                        }
                    });
                    valueArray = arrStr;
                    valueRefId = arrRefId;
                } else if (rule.filter.valueDataType == 'AutoCompleteDropdown' && MultiSelectFieldsNS.AutoCompleteProductFieldsArray.includes(rule.filter.field?.toLowerCase())) {
                    let arrStr = [];
                    if (rule.value?.item2) {
                        arrStr = [rule.value?.item2];
                    }
                    else if (rule.value) {
                        arrStr = [rule.value];
                    }
                    valueArray = arrStr;
                }
                else {
                    valueArray = [rule.value];
                }
            }
        }
        //Number
        else if (rule.filter.fieldDataType == 'Number' || rule.filter.fieldDataType == 'Decimal' || rule.filter.fieldDataType == 'Money') {
            if (rule.filter.valueDataType == 'Number' || rule.filter.valueDataType == 'Decimal') {
                if (selectedDataTypeAndOperator?.NoOfValuesToBePassed == 'No_Value') {
                    valueArray = [];
                }
                else if (selectedDataTypeAndOperator?.NoOfValuesToBePassed == 'Single_Value') {
                    valueArray = [rule.value];
                }
                else if (selectedDataTypeAndOperator?.NoOfValuesToBePassed == 'Between_Value') {
                    const dateFrom = rule.value;
                    const dateTo = rule.value2;
                    if ((dateFrom || dateFrom>=0) && (dateTo || dateTo>=0)) {
                        const dateFromAndTo = `${dateFrom} AND ${dateTo}`;
                        valueArray = [dateFromAndTo];
                    }
                }
                else {
                    valueArray = [rule.value];
                }
            }
        }
        // Distance
        else if (rule?.filter?.fieldDataType == 'Distance') {
            let addressLatLng: SavedSearchNS.AddressLatLong = {
                address: rule.value.address,
                latitude: rule.value.latitude,
                longitude: rule.value.longitude,
                radius: rule.value.radius,
            };
            valueArray = [JSON.stringify(addressLatLng)];
        }
        //Boolean
        else if (rule?.filter?.fieldDataType == 'Boolean') {
            valueArray = rule.value?.name == 'true' ? [true] : [false];
        }
        //DateTime
        else if (rule?.filter?.fieldDataType == 'DateTime') {
            if (selectedDataTypeAndOperator?.NoOfValuesToBePassed == 'No_Value') {
                valueArray = [];
            }
            else if (selectedDataTypeAndOperator?.NoOfValuesToBePassed == 'Single_Value') {
                if (selectedDataTypeAndOperator?.Operator == 'Is') {
                    // const dateFrom = rule.value?.toLocaleDateString('sv');
                    const dateFrom = rule.value2?.code;
                    if (dateFrom) {
                        if (dateFrom == 'custom') {
                            const dateFromValue = convertToLocalDateString(rule.value);
                            if (dateFromValue) {
                                valueArray = [dateFromValue];
                            }
                        }
                        else {
                            valueArray = [dateFrom];
                        }
                    }
                }
                else {
                    const dateFrom = convertToLocalDateString(rule.value);
                    valueArray = [dateFrom];
                }
            }
            else if (selectedDataTypeAndOperator?.NoOfValuesToBePassed == 'Between_Value') {
                const dateFrom = convertToLocalDateString(rule.value?.[0]);
                const dateTo = convertToLocalDateString(rule.value?.[1]);
                if (dateFrom && dateTo) {
                    const dateFromAndTo = `${dateFrom} AND ${dateTo}`;
                    valueArray = [dateFromAndTo];
                }
            }
            else {
                valueArray = [rule.value];
            }
        }
        //Time
        else if (rule?.filter?.fieldDataType == 'Time') {
            if (selectedDataTypeAndOperator?.NoOfValuesToBePassed == 'No_Value') {
                valueArray = [];
            } else if (selectedDataTypeAndOperator?.NoOfValuesToBePassed == 'Between_Value') {
                valueArray = [rule.value,rule.value2];
            } else {
                valueArray = [rule.value];
            }
        }
        //Enum
        else if (rule.filter.fieldDataType == 'Enum') {
            if (selectedDataTypeAndOperator?.Operator == 'HasValue' || selectedDataTypeAndOperator?.Operator == 'NoValue') {
                valueArray = [];
                valueRefId = [];
            } else {
                if (rule.filter.valueDataType == 'MultiSelect' || rule.filter.valueDataType == 'MultiSelectAPI') {
                    let arrStr = [];
                    let arrRefId: string[] = [];
                    rule?.value?.forEach((val: any) => {
                        arrStr.push(val.name);
                        if (val?.id?.toString()) {
                            arrRefId.push(val.id.toString());
                        }
                    });

                    valueArray = arrStr;
                    valueRefId = arrRefId;
                }
                else if (rule.filter.valueDataType == 'User') {
                    let arrStr = [];
                    let arrRefId: string[] = [];
                    rule?.value?.forEach((val: any) => {
                        arrStr.push(val.name);
                        if (val?.id?.toString()) {
                            arrRefId.push(val.id.toString());
                        }
                    });
                    valueArray = arrStr;
                    valueRefId = arrRefId;
                }
                else if (rule.filter.valueDataType == 'Country') {
                    // let countryArrStr = this.getCountryStateCity(rule) ?? [];
                    // valueArray = [JSON.stringify(countryArrStr)];

                    valueArray = [rule.value.name];
                    valueRefId = [rule.value.id];
                }
                else if (rule.filter.valueDataType == 'DropdownList') {
                    valueArray = [rule.value.name];
                    valueRefId = [rule.value.id];
                }
                else if (rule.filter.valueDataType == 'TreeSelect' && rule.filter.field?.toLowerCase() == 'territoryname') {
                    let parent = rule?.value?.parent;
                    let territoryName: SavedSearchNS.TerritoryNameObject;
                    if (parent) {
                        territoryName = {
                            country: parent?.label,
                            countryId: parent?.id,
                            name: rule.value.label,
                            territoryId: rule.value.id,
                        }
                    }
                    else {
                        territoryName = {
                            country: rule.value.label,
                            countryId: rule.value.id,
                            name: null,
                            territoryId: null,
                        }
                    }

                    // valueArray = [rule.value.name];
                    // valueRefId = [rule.value.id];
                    valueArray = [JSON.stringify(territoryName)];
                }
                else if (rule.filter.valueDataType == 'TreeSelect' && rule.filter.field?.toLowerCase() != 'territoryname') {

                    let arrStr = [];
                    let arrRefId: string[] = [];
                    rule?.value?.forEach((val: any) => {
                        arrStr.push(val.name);
                        if (val?.id?.toString()) {
                            arrRefId.push(val.id.toString());
                        }
                    });
                    valueArray = arrStr;
                    valueRefId = arrRefId;
                }
                else {
                    valueArray = [rule.value];
                }
            }

        }
    }
    return { values: valueArray, valueRefId: valueRefId ?? [] };
}


export function convertToLocalDateString(value: any){
    if(value instanceof Date){
        return value.toLocaleDateString('sv');
    }else{
        value = new Date(value);
        return value.toLocaleDateString('sv');
    }
}

export function getSavedSearchTreeRuleValues(rule: SavedSearchNS.IRuleList) {
    if(rule.filter?.valueDataType == 'TreeSelect' && (rule.operator?.name != 'HasValue' && rule.operator?.name != 'NoValue')){
        if(rule.filter?.mapObject == 'territory'){
            let parent = rule?.value?.parent||null;
            if (parent) {
                parent = {
                    id: parent.id,
                    name: parent.name,
                    label: parent.label,
                }
            }

            rule.value = {
                id: rule.value.id,
                name: rule.value.name,
                label: rule.value.label,
                parent: parent
            }
        }else{
            rule.value = (rule.value?.length>0 && rule.value[0]?.value) ? savedSearchSetValueForTree(rule.value) : rule.value;
        }
    }

    return rule;
}

export function savedSearchSetValueForTree(value) {
    const values = [];
    for (let val of value) {
        const obj = {
            id: val.value?.id,
            name: val.value?.name
        }
        values.push(obj);
    }
    return values;
}

export function savedSearchRuleNo(addedRules: SavedSearchNS.IRuleList[]): string {
    let addedRuleNo: number[] = addedRules.filter(rule=> rule?.ruleNo).map(rule=> rule?.ruleNo ? Number(rule?.ruleNo.replace(/#/g, '')) : 0);
    let ruleNo: number = 1;

    if(addedRuleNo?.length>0){
        addedRuleNo = addedRuleNo.sort((a,b)=> b - a);
        ruleNo = addedRuleNo[0] + 1;
    }

    return `#${ruleNo}#`;
}
